import { title } from 'process';
import { CurrentFaseModel } from './../../pages/shared/fase/fase.model';
import { FaseService } from './../../pages/shared/fase/fase.service';
import { Component, OnDestroy, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DOCUMENT, DatePipe } from '@angular/common';
import { navItems, navItemsOtorAdmin, navItemsOtorDinasTeknis, navItemsOtorPejabatKeuangan, navItemsOtorPejabatTeknis, navItemsOtorPemimpinBLUD, navItemsOtorPemimpinBLUDFase3, navItemsOtorSuperAdmin, navItemsOtorTAPD } from '../../_nav';
import { CurrentUser, PenggunaModel } from '../../_model/auth/authentication.model';
import { TahunAnggaranComponent } from '../../pages/shared/tahun-anggaran/tahun-anggaran.component';
import { Router, RouterOutlet } from '@angular/router';
import { BatasInputanService } from '../../pages/shared/batas-inputan/batas-inputan.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild(RouterOutlet) routerOutlet: RouterOutlet;
  @ViewChild(TahunAnggaranComponent) tahunAnggaranComponent: TahunAnggaranComponent;

  public navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;
  fase: CurrentFaseModel = new CurrentFaseModel();
  selectedFase: number;
  tglAkhir: any;
  tgl
  status: any;
  pengguna: PenggunaModel;
  tahunAnggaran: any = localStorage.getItem('defaultYear')?.replace(/\D/g, '');
  showTime: boolean = false;

  constructor(
    private datePipe: DatePipe,
    private faseService: FaseService,
    private batasInputanService: BatasInputanService,
    private router: Router,
    @Inject(DOCUMENT) _document?: any,
  ) {
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, { attributes: true, attributeFilter: ['class'] });
  }

  ngOnInit(): void {
    const local: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.pengguna = local.pengguna;
    this.faseService.getCurrentFase().subscribe(response => {
      this.fase = response;
      this.selectedFase = response.idFase;
      this.setNavItems();
    });

    this.batasInputanService.getStatusBySkpd().subscribe((response) => {
      if (response.status === 200) {
        const { isLock, isLockSkpd, isLockPending, tglMulai, tglAkhir } = response.body;
        localStorage.setItem('isLock', isLock);
        localStorage.setItem('isLockSkpd', isLockSkpd);
        localStorage.setItem('isLockPending', isLockPending);

        this.status = isLockSkpd;
        const now = new Date();
        const startDate = new Date(tglMulai);
        const endDate = new Date(tglAkhir);

        let targetDate: Date | null = null;
        let title: string;

        // === LOGIKA SESUAI DB ===
        if (isLock == 1 && isLockSkpd == 1 && isLockPending == 0) {
          // Dibuka tapi belum dimulai
          if (now < startDate) {
            targetDate = startDate;
            title = 'Inputan akan dibuka pada tanggal';
          } else {
            // sudah lewat start tapi masih lock (edge case)
            targetDate = endDate;
            title = 'Inputan akan ditutup pada tanggal';
          }
        }
        else if (isLock == 0 && isLockSkpd == 0 && isLockPending == 0) {
          // Sedang berlangsung
          if (now < endDate) {
            targetDate = endDate;
            title = 'Inputan akan ditutup pada tanggal';
          } else {
            title = 'Waktu Inputan telah Berakhir';
          }
        }
        else {
          // Kondisi tutup atau tidak diketahui
          title = 'Waktu Inputan telah Berakhir';
        }

        // === Format tanggal ke Indonesia dan mulai countdown ===
        if (targetDate) {
          const dateInEnglish = this.datePipe.transform(targetDate, 'EEEE, dd MMMM yyyy, HH:mm:ss', 'en-US');
          if (dateInEnglish) {
            const dayNamesInIndonesian = {
              Sunday: 'Minggu', Monday: 'Senin', Tuesday: 'Selasa', Wednesday: 'Rabu',
              Thursday: 'Kamis', Friday: 'Jumat', Saturday: 'Sabtu'
            };
            const monthNamesInIndonesian = {
              January: 'Januari', February: 'Februari', March: 'Maret', April: 'April',
              May: 'Mei', June: 'Juni', July: 'Juli', August: 'Agustus',
              September: 'September', October: 'Oktober', November: 'November', December: 'Desember'
            };

            const [dayNameInEnglish, restOfDate] = dateInEnglish.split(', ');
            const [day, monthNameInEnglish, yearAndTime] = restOfDate.split(' ');
            const dayNameInIndonesian = dayNamesInIndonesian[dayNameInEnglish];
            const monthNameInIndonesian = monthNamesInIndonesian[monthNameInEnglish];
            this.tglAkhir = `${dayNameInIndonesian}, ${day} ${monthNameInIndonesian} ${yearAndTime}`;
          }

          this.startCooldown(targetDate.toISOString(), title);
        }
      }
    });
  }

  ngAfterViewInit(): void {
    const url = this.router.url;
    if (!this.routerOutlet.isActivated) {
      this.router.navigate([url]);
    }
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }

  toggleShowTime(): void {
    this.showTime = !this.showTime;
  }

  startCooldown(tglAkhir: string, title: string): void {
    const endDate = new Date(tglAkhir).getTime();
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endDate - now;
      const titleElement = document.getElementById('title');
      const subtitleElement = document.getElementById('subtitle');
      const timeElement = document.getElementById('time-cooldown');

      if (!titleElement || !subtitleElement || !timeElement) return;

      if (distance < 0) {
        clearInterval(timer);
        titleElement.textContent = 'Waktu Inputan telah Berakhir';
        subtitleElement.textContent = 'Silahkan hubungi Admin untuk membuka kembali akses';
        timeElement.textContent = '-';
        return;
      }

      const hours = String(Math.floor(distance / (1000 * 60 * 60))).padStart(2, '0');
      const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0');
      const milliseconds = String(distance % 1000).padStart(3, '0');

      titleElement.textContent = title;
      subtitleElement.textContent = this.tglAkhir;
      timeElement.textContent = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    }, 50);
  }

  openModal() {
    this.tahunAnggaranComponent.openModalEvent.emit();
  }

  setNavItems() {
    switch (this.pengguna.otor) {
      case '0':
        this.navItems = navItemsOtorPejabatTeknis;
        break;
      case '1':
        this.navItems = navItemsOtorPejabatKeuangan;
        break;
      case '2':
        if (this.selectedFase !== 1) {
          this.navItems = navItemsOtorPemimpinBLUDFase3;
        } else {
          this.navItems = navItemsOtorPemimpinBLUD;
        }
        break;
      case '3':
        this.navItems = navItemsOtorDinasTeknis;
        break;
      case '4':
        if (localStorage.getItem('viewAsSkpd')) {
          this.navItems = navItemsOtorPejabatTeknis.concat([{
            name: 'Kembali',
            url: `/${this.tahunAnggaran}/skpd`,
            icon: 'icon-arrow-left',
            attributes: { class: 'bg-warning p-3 text-white' }
          }]);
        } else {
          this.navItems = navItemsOtorTAPD;
        }
        break;
      case '8':
        this.navItems = navItemsOtorAdmin;
        break;
      case '9':
        this.navItems = navItemsOtorSuperAdmin;
        break;
      default:
        this.navItems = navItems;
        break;
    }
  }

  getCurrentFase() {
    this.faseService.getCurrentFase().subscribe(response => {
      this.fase = response; this.selectedFase = response.idFase;
    });
  }
}
